<div>
    <p class="noaccess">Your user account does not have access to Lab Partner.</p>
    <p [innerHTML]="contactMessage"></p>
    
    <!-- Test Mode Login Button -->
    <div *ngIf="environment.testMode" class="test-login-section">
        <h3>Test Mode</h3>
        <p>You are in test mode. Please select a test user to continue:</p>
        <button mat-raised-button color="primary" (click)="showTestLoginDialog()">
            <mat-icon>login</mat-icon>
            Login as Test User
        </button>
    </div>
</div>

